import React from "react";
import { DazzlerIcon, GrenadeIcon, KineticStrikeIcon, PepperHotIcon, SonicIcon, TearGasIcon } from "../Reuse/Icon";

export const staticVar = {
  idle: "idle",
  loading: "loading",
  pending: "pending",
  upload: "upload",
  error: "error",
  done: "done",
  process: "process",
};

export const deleteMsg = {
  User: "User has been deleted",
  AppRelease:"",
  Firmware:"",
};

export const DroneIcon = React.memo((props) => {
  const { icon, sx = {} } = props;
  return (
    <React.Fragment>
      {icon === "DAZZLER" ? (
        <DazzlerIcon fontSize="small" sx={{ color: "#00FF66", ...sx }} />
      ) : null}
      {icon === "KINETIC_STRIKE" ? (
        <KineticStrikeIcon fontSize="small" sx={{ color: "#000000", ...sx }} />
      ) : null}
      {icon === "PEPPER_HOT" ? (
        <PepperHotIcon fontSize="small" sx={{ color: "#FF0000", ...sx }} />
      ) : null}
      {icon === "SONIC" ? (
        <SonicIcon fontSize="small" sx={{ color: "#2E90FA", ...sx }} />
      ) : null}
      {icon === "GRENADE" ? (
        <GrenadeIcon fontSize="small" sx={{ color: "#FFC60D", ...sx }} />
      ) : null}
      {icon === "TEAR_GAS" ? (
        <TearGasIcon fontSize="small" sx={{ color: "#2ED3B7", ...sx }} />
      ) : null}
    </React.Fragment>
  );
});